<template>
    <select class="form-control" id="statelist" placeholder="State" @change="handleChange">
        <option data-country="76" value="Acre">Acre</option>
        <option data-country="76" value="Alagoas">Alagoas</option>
        <option data-country="76" value="Amapá">Amapá</option>
        <option data-country="76" value="Amazonas">Amazonas</option>
        <option data-country="76" value="Bahia">Bahia</option>
        <option data-country="76" value="Ceará">Ceará</option>
        <option data-country="76" value="Distrito Federal">Distrito Federal</option>
        <option data-country="76" value="Espírito Santo">Espírito Santo</option>
        <option data-country="76" value="Goiás">Goiás</option>
        <option data-country="76" value="Maranhão">Maranhão</option>
        <option data-country="76" value="Mato Grosso">Mato Grosso</option>
        <option data-country="76" value="Mato Grosso do Sul">Mato Grosso do Sul</option>
        <option data-country="76" value="Minas Gerais">Minas Gerais</option>
        <option data-country="76" value="Pará">Pará</option>
        <option data-country="76" value="Paraíba">Paraíba</option>
        <option data-country="76" value="Paraná">Paraná</option>
        <option data-country="76" value="Pernambuco">Pernambuco</option>
        <option data-country="76" value="Piauí">Piauí</option>
        <option data-country="76" value="Rio de Janeiro">Rio de Janeiro</option>
        <option data-country="76" value="Rio Grande do Norte">Rio Grande do Norte</option>
        <option data-country="76" value="Rio Grande do Sul">Rio Grande do Sul</option>
        <option data-country="76" value="Rondônia">Rondônia</option>
        <option data-country="76" value="Roraima">Roraima</option>
        <option data-country="76" value="Santa Catarina">Santa Catarina</option>
        <option data-country="76" value="São Paulo">São Paulo</option>
        <option data-country="76" value="Sergipe">Sergipe</option>
        <option data-country="76" value="Tocantins">Tocantins</option>
    </select>
</template>

<script>
export default {
methods: {
    handleChange (e) {
      // Set Regus State.
      if(e.target.options.selectedIndex > -1) {
        let regusState = e.target.value;
        this.$store.commit('setRegusState', regusState);
      }
    }
  }
}
</script>

<style>

</style>
